import { render, staticRenderFns } from "./AttributeFormRow.vue?vue&type=template&id=b566dc96&"
import script from "./AttributeFormRow.vue?vue&type=script&lang=js&"
export * from "./AttributeFormRow.vue?vue&type=script&lang=js&"
import style0 from "./AttributeFormRow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports